import { DefaultButton, Spinner } from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import { useState } from "react";

import { entryViewIcon } from "../../../../../utils/icons";
import PdfDocument from "../../../PdfDocument";

export default () => {
  const [loading, { setTrue, setFalse }] = useBoolean(false);

  return (
    <>
      {loading && <Spinner />}
      <DefaultButton
        text="Önizle"
        disabled={loading}
        iconProps={entryViewIcon}
        onClick={() => {
          setTrue();

          const pdfDocument = new PdfDocument();

          pdfDocument
            .preview()
            .then(() => setFalse())
            .catch(() => setFalse());
        }}
      />
    </>
  );
};
